import { Directive, HostBinding } from "@angular/core";

@Directive({
    selector: "[ng-displayBind]",
    standalone: false
})
export class DisplayBindDirective {
  @HostBinding("style.display") display = "contents";
}
